// 주로 백엔드에 보낼 때 사용하는 Flag 변수
export const PAY = 1
export const RECEIVE_BY_PRIZE = 2
export const RECEIVE_DIRECT = 3
export const WITHDRAW_BY_MANAGER = 4
export const WITHDRAW_BY_ADMIN = 5

// 주로 백엔드에서 온 값을 출력할 때 사용하는 Object
export const convertRecordTypeAsName = {
    "1": "지불",
    "2": "프라이즈로 수령",
    "3": "직접 수령",
    "4": "매니저에 의해 회수됨",
    "5": "관리자에 의해 회수됨"
}